import React from "react";
import MainLayout from "./MainLayout";
import Benefits from "../common/MainContent/Home/Benefits";

const BenefitsPage = (props) => <MainLayout component={Benefits} />;

export default BenefitsPage;
